import { render } from "./AdminCardSimple.vue?vue&type=template&id=5f835a1c"
import script from "./AdminCardSimple.vue?vue&type=script&lang=js"
export * from "./AdminCardSimple.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__